module.exports = __webpack_public_path__ + "static/media/location_ruka.a00cc8e2.jpg";